const state = {
  errors: [],
  statusCode: ''
}

export const apierrors = {
  namespaced: true,
  state
}



// WEBPACK FOOTER //
// ./src/store/apierror.module.js